import React from 'react'

function Footer() {
  return (
    <div className="container-fluid copyright text-light py-1">
      <div className="row">
        <div className="col text-start ps-2">
          <div className="col-md-6 text-center text-md-start">
            © <a href="#">ANZA Software Technologies</a> | All Rights Reserved
          </div>
        </div>
      </div>
    </div>
  );
}
// function Footer() {
//   return (
//     <div>
//     {/* Footer Start */}
//         {/* Copyright Start */}
//         <div className="container-fluid copyright text-light py-1 wow fadeIn" data-wow-delay="0.1s">
//           <div className="container">
//             <div className="row">
//               <div className="col-md-6 text-center text-md-start mb-3 mb-md-0">
//                 © <a href="#">ANZA Software Technologies</a> All Rights Reserved
//               </div>
//               <div className="col-md-6 text-center text-md-end">
//                 {/*/*** This template is free as long as you keep the footer author’s credit link/attribution link/backlink. If you'd like to use the template without the footer author’s credit link/attribution link/backlink, you can purchase the Credit Removal License from "https://htmlcodex.com/credit-removal". Thank you for your support. *** /*/}
//                 {/* Developed By <a href="https://htmlcodex.com">ANZA Software Technologies</a> */}
//                 {/* <br />Distributed By: <a href="https://themewagon.com" target="_blank">ThemeWagon</a> */}
//               </div>
//             </div>
//           </div>
//         </div>
//         {/* Copyright End */}
//         {/* Back to Top */}
//         {/* <a href="#" className="btn btn-lg btn-primary btn-lg-square back-to-top"><i className="bi bi-arrow-up" /></a> */}
//       </div> 
//   )
// }

export default Footer